import { render, staticRenderFns } from "./inChargeManagement.vue?vue&type=template&id=e5565718&scoped=true&"
import script from "./inChargeManagement.vue?vue&type=script&lang=js&"
export * from "./inChargeManagement.vue?vue&type=script&lang=js&"
import style0 from "./inChargeManagement.vue?vue&type=style&index=0&id=e5565718&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5565718",
  null
  
)

export default component.exports